import React from 'react'
import { MODE } from '../../constants/mode'
import { getMode } from '../../hooks/mode'
import './formField.less'

interface Props {
  id?: string
  classFormField?: string
  label: string
  sublabel?: string
  isError?: boolean
  children: React.ReactElement
  isClearNeed?: boolean
  isExtendedClearNeed?: boolean
  clearInputField?: any
  currentInput?: any
}

export const FormField = (props: Props) => {
  const mode = getMode()
  const {
    id,
    label,
    sublabel,
    isError,
    children,
    isClearNeed = false,
    isExtendedClearNeed = false,
    clearInputField,
    currentInput,
  } = props

  let { classFormField } = props
  if (!classFormField) {
    if (mode === MODE.MOBILE) {
      classFormField = 'form-field-mobile'
    } else if (mode === MODE.DESKTOP) {
      classFormField = 'form-field show-cursor'
    } else {
      classFormField = 'form-field'
    }
  }

  return (
    <div id={id} className={classFormField}>
      <div className="label">{label}</div>
      {children}
      {(isClearNeed || isExtendedClearNeed) && (
        <div className={`clear-input ${isExtendedClearNeed && 'extended-clear-input'}`}>
          <button
            tabIndex={-1}
            className={`clear-input-button ${isExtendedClearNeed && 'extended-clear-input-button'}`}
            onClick={() => clearInputField(currentInput)}
          >
            &#xd7;
          </button>
        </div>
      )}
      {sublabel && <div className={isError ? 'sub-label isError' : 'sub-label'}>{sublabel}</div>}
    </div>
  )
}
